const ModalBodyTheme = {
  scrollable: "overflow-y-auto",
  wrapper: "relative flex-auto p-4",
};

export default ModalBodyTheme;
